var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", {
        ref: "animationContainer",
        staticClass: "landing-lottie-animation",
        style: _vm.customStyles,
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }